// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "7fc300b4c3d1b84fffd9ce777400c454" + ".js";
};